export default __webpack_public_path__ + "static/media/Ballroll_00385.c0885af6.png";